import * as ambassadorWixPricingPlansSettingsV1PricingPlansSettings from './pricing-plans-settings-v1-pricing-plans-settings-pricing-plans-settings.http.js';
import * as ambassadorWixPricingPlansSettingsV1PricingPlansSettingsTypes from './pricing-plans-settings-v1-pricing-plans-settings-pricing-plans-settings.types.js';
import * as ambassadorWixPricingPlansSettingsV1PricingPlansSettingsUniversalTypes from './pricing-plans-settings-v1-pricing-plans-settings-pricing-plans-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getPricingPlansSettings(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPricingPlansSettingsV1PricingPlansSettingsUniversalTypes.GetPricingPlansSettingsRequest,
  ambassadorWixPricingPlansSettingsV1PricingPlansSettingsTypes.GetPricingPlansSettingsRequest,
  ambassadorWixPricingPlansSettingsV1PricingPlansSettingsUniversalTypes.GetPricingPlansSettingsResponse,
  ambassadorWixPricingPlansSettingsV1PricingPlansSettingsTypes.GetPricingPlansSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPricingPlansSettingsV1PricingPlansSettings.getPricingPlansSettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/pricing-plans-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updatePricingPlansSettings(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixPricingPlansSettingsV1PricingPlansSettingsUniversalTypes.UpdatePricingPlansSettingsRequest,
  ambassadorWixPricingPlansSettingsV1PricingPlansSettingsTypes.UpdatePricingPlansSettingsRequest,
  ambassadorWixPricingPlansSettingsV1PricingPlansSettingsUniversalTypes.UpdatePricingPlansSettingsResponse,
  ambassadorWixPricingPlansSettingsV1PricingPlansSettingsTypes.UpdatePricingPlansSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPricingPlansSettingsV1PricingPlansSettings.updatePricingPlansSettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/pricing-plans-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  PricingPlansSettings as PricingPlansSettingsOriginal,
  TaxableAddress as TaxableAddressOriginal,
  TaxableAddressWithLiterals as TaxableAddressWithLiteralsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  GuestCheckoutSettings as GuestCheckoutSettingsOriginal,
  InvoiceSettings as InvoiceSettingsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  GetPricingPlansSettingsRequest as GetPricingPlansSettingsRequestOriginal,
  GetPricingPlansSettingsResponse as GetPricingPlansSettingsResponseOriginal,
  UpdatePricingPlansSettingsRequest as UpdatePricingPlansSettingsRequestOriginal,
  UpdatePricingPlansSettingsResponse as UpdatePricingPlansSettingsResponseOriginal,
  FeatureEvent as FeatureEventOriginal,
  FeatureEventEventOneOf as FeatureEventEventOneOfOriginal,
  FeatureEnabled as FeatureEnabledOriginal,
  FeatureEnabledReasonOneOf as FeatureEnabledReasonOneOfOriginal,
  Feature as FeatureOriginal,
  FeatureQuantityInfoOneOf as FeatureQuantityInfoOneOfOriginal,
  FeatureContext as FeatureContextOriginal,
  BooleanFeature as BooleanFeatureOriginal,
  QuotaFeature as QuotaFeatureOriginal,
  FeaturePeriod as FeaturePeriodOriginal,
  FeaturePeriodWithLiterals as FeaturePeriodWithLiteralsOriginal,
  QuotaInfo as QuotaInfoOriginal,
  QuotaInfoEntry as QuotaInfoEntryOriginal,
  TransferredFromAnotherAccountReason as TransferredFromAnotherAccountReasonOriginal,
  ReassignedFromSiteReason as ReassignedFromSiteReasonOriginal,
  AssignedFromFloatingReason as AssignedFromFloatingReasonOriginal,
  NewFeatureReason as NewFeatureReasonOriginal,
  ContractSwitchedReason as ContractSwitchedReasonOriginal,
  ContractSwitchClassification as ContractSwitchClassificationOriginal,
  ContractSwitchClassificationWithLiterals as ContractSwitchClassificationWithLiteralsOriginal,
  ManualFeatureCreationReason as ManualFeatureCreationReasonOriginal,
  MigratedFromLegacyReason as MigratedFromLegacyReasonOriginal,
  ManualSyncReason as ManualSyncReasonOriginal,
  FeatureDisabled as FeatureDisabledOriginal,
  FeatureDisabledReasonOneOf as FeatureDisabledReasonOneOfOriginal,
  UnAssingedToFloatingReason as UnAssingedToFloatingReasonOriginal,
  ReplacedByAnotherSubscriptionReason as ReplacedByAnotherSubscriptionReasonOriginal,
  ReassignedToAnotherSiteReason as ReassignedToAnotherSiteReasonOriginal,
  FeatureUpdated as FeatureUpdatedOriginal,
  FeatureUpdatedPreviousQuantityInfoOneOf as FeatureUpdatedPreviousQuantityInfoOneOfOriginal,
  FeatureUpdatedReasonOneOf as FeatureUpdatedReasonOneOfOriginal,
  FeatureCancelled as FeatureCancelledOriginal,
  FeatureCancelledReasonOneOf as FeatureCancelledReasonOneOfOriginal,
  TransferredToAnotherAccountReason as TransferredToAnotherAccountReasonOriginal,
  CancelRequestedReason as CancelRequestedReasonOriginal,
  QuotaExhaustedReason as QuotaExhaustedReasonOriginal,
  FeatureQuotaUsageChanged as FeatureQuotaUsageChangedOriginal,
  Empty as EmptyOriginal,
  SubscriptionEvent as SubscriptionEventOriginal,
  SubscriptionEventEventOneOf as SubscriptionEventEventOneOfOriginal,
  SubscriptionCreated as SubscriptionCreatedOriginal,
  Subscription as SubscriptionOriginal,
  BillingReference as BillingReferenceOriginal,
  ProviderName as ProviderNameOriginal,
  ProviderNameWithLiterals as ProviderNameWithLiteralsOriginal,
  Cycle as CycleOriginal,
  CycleCycleSelectorOneOf as CycleCycleSelectorOneOfOriginal,
  Interval as IntervalOriginal,
  IntervalUnit as IntervalUnitOriginal,
  IntervalUnitWithLiterals as IntervalUnitWithLiteralsOriginal,
  OneTime as OneTimeOriginal,
  SubscriptionStatus as SubscriptionStatusOriginal,
  SubscriptionStatusWithLiterals as SubscriptionStatusWithLiteralsOriginal,
  ReactivationData as ReactivationDataOriginal,
  ReactivationReasonEnum as ReactivationReasonEnumOriginal,
  ReactivationReasonEnumWithLiterals as ReactivationReasonEnumWithLiteralsOriginal,
  SubscriptionAssigned as SubscriptionAssignedOriginal,
  SubscriptionCancelled as SubscriptionCancelledOriginal,
  CancellationDetails as CancellationDetailsOriginal,
  Initiator as InitiatorOriginal,
  InitiatorWithLiterals as InitiatorWithLiteralsOriginal,
  RefundType as RefundTypeOriginal,
  RefundTypeWithLiterals as RefundTypeWithLiteralsOriginal,
  SubscriptionAutoRenewTurnedOn as SubscriptionAutoRenewTurnedOnOriginal,
  SubscriptionAutoRenewTurnedOff as SubscriptionAutoRenewTurnedOffOriginal,
  SubscriptionUnassigned as SubscriptionUnassignedOriginal,
  UnassignReason as UnassignReasonOriginal,
  UnassignReasonWithLiterals as UnassignReasonWithLiteralsOriginal,
  SubscriptionTransferred as SubscriptionTransferredOriginal,
  RecurringChargeSucceeded as RecurringChargeSucceededOriginal,
  ContractSwitched as ContractSwitchedOriginal,
  ContractSwitchType as ContractSwitchTypeOriginal,
  ContractSwitchTypeWithLiterals as ContractSwitchTypeWithLiteralsOriginal,
  ContractSwitchReason as ContractSwitchReasonOriginal,
  ContractSwitchReasonWithLiterals as ContractSwitchReasonWithLiteralsOriginal,
  ProductPriceIncreaseData as ProductPriceIncreaseDataOriginal,
  PriceIncreaseTrigger as PriceIncreaseTriggerOriginal,
  PriceIncreaseTriggerWithLiterals as PriceIncreaseTriggerWithLiteralsOriginal,
  ProductAdjustment as ProductAdjustmentOriginal,
  ProductAdjustmentWithLiterals as ProductAdjustmentWithLiteralsOriginal,
  SubscriptionNearEndOfPeriod as SubscriptionNearEndOfPeriodOriginal,
  SubscriptionPendingChange as SubscriptionPendingChangeOriginal,
  RecurringChargeAttemptFailed as RecurringChargeAttemptFailedOriginal,
  RecurringChargeFailureReason as RecurringChargeFailureReasonOriginal,
  RecurringChargeFailureReasonWithLiterals as RecurringChargeFailureReasonWithLiteralsOriginal,
  SubscriptionUpdated as SubscriptionUpdatedOriginal,
  SubscriptionMigratedFromVista as SubscriptionMigratedFromVistaOriginal,
  SubscriptionVistaMigrationReverted as SubscriptionVistaMigrationRevertedOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
} from './pricing-plans-settings-v1-pricing-plans-settings-pricing-plans-settings.types.js';
